import { IncomeType } from '../../../../api/useWhatIfOptionsQuery';

export interface FormValues {
  WhatIfKey: string;
  WhatIfType: number;
  WhatIfTypeName: string;
  Incomes: {
    Type: IncomeType | null;
    IsBasePlanIncome: boolean;
    Earner: string | null;
  }[];
}

export const DEFAULT_INCOME = {
  Type: null,
  IsBasePlanIncome: false,
};

export const DEFAULT_VALUES: FormValues = {
  Incomes: [],
  WhatIfKey: '1200',
  WhatIfType: 1200,
  WhatIfTypeName: 'IncomeChanges',
};
